import {FormFieldTypeValidationEnum} from 'src/api/ProactApiClient';
import type {ISelectOption} from 'src/types/Form';
import {FormFieldTypeLegacyEnum} from 'src/types/Form';

const fieldTypeDictionary: any = {
  asset: {
    assetModal: true,
    formFieldType: FormFieldTypeLegacyEnum.AssetModal,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  'date-picker': {
    datePicker: true,
    formFieldType: FormFieldTypeLegacyEnum.Date,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  'phone-number': {
    phoneNumber: true,
    formFieldType: FormFieldTypeLegacyEnum.PhoneNumber,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  'time-picker': {
    datePicker: true,
    formFieldType: FormFieldTypeLegacyEnum.Time,
  },
  'document-upload': {
    documentUpload: true,
    formFieldType: FormFieldTypeLegacyEnum.FileUpload,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  'single-document-upload': {
    singleDocumentUpload: true,
    formFieldType: FormFieldTypeLegacyEnum.SingleFileUpload,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  'image-upload': {
    documentUpload: true,
    formFieldType: FormFieldTypeLegacyEnum.ImageUpload,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  'single-text': {
    textBox: true,
    hasValidationType: true,
    formFieldType: FormFieldTypeLegacyEnum.TextInput,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
      showMultiline: true,
    },
  },

  'yes-no': {
    switch: true,
    options: {
      positivelabel: 'Yes',
      negativelabel: 'No',
      isNAEnabled: true,
    },
    formFieldType: FormFieldTypeLegacyEnum.Checkbox,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  'item-select-single': {
    singleSelect: true,
    select: true,
    formFieldType: FormFieldTypeLegacyEnum.Dropdown,
    options: {
      optionType: 'custom',
    },
    fieldSettingsVisibleOptions: {
      showDropDownType: true,
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  signature: {
    signature: true,
    select: true,
    formFieldType: FormFieldTypeLegacyEnum.Signature,
    fieldSettingsVisibleOptions: {
      showDropDownType: true,
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  autocomplete: {
    autocomplete: true,
    select: true,
    formFieldType: FormFieldTypeLegacyEnum.DropdownAutocomplete,
    fieldSettingsVisibleOptions: {
      showDropDownType: true,
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  'item-select-multiple': {
    selectModal: true,
    formFieldType: FormFieldTypeLegacyEnum.DropdownModal,
  },
  'person-select-multiple': {
    personSelectModal: true,
    formFieldType: FormFieldTypeLegacyEnum.DropdownPersonnelModal,
  },
  'rich-content': {
    richContent: true,
    formFieldType: FormFieldTypeLegacyEnum.RichText,
    fieldSettingsVisibleOptions: {
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  paragraph: {
    paragraph: true,
    formFieldType: FormFieldTypeLegacyEnum.Paragraph,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showDescription: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  heading: {
    heading: true,
    formFieldType: FormFieldTypeLegacyEnum.Heading,
    fieldSettingsVisibleOptions: {showLabel: true},
  },
  divider: {
    divider: true,
    formFieldType: FormFieldTypeLegacyEnum.Divider,
    fieldSettingsVisibleOptions: {},
  },
  textarea: {
    textArea: true,
    formFieldType: FormFieldTypeLegacyEnum.TextInput,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultValue: true,
      showReadOnly: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
      showMultiline: true,
    },
  },
  subform: {
    subform: true,
    formFieldType: FormFieldTypeLegacyEnum.Subform,
    fieldSettingsVisibleOptions: {
      showSubFormsList: true,
      showSubFormType: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
  scale: {
    scale: true,
    options: {isNAEnabled: true},
    formFieldType: FormFieldTypeLegacyEnum.Scale,
    fieldSettingsVisibleOptions: {
      showLabel: true,
      showActive: true,
      showRequired: true,
      showHelpText: true,
      showDefaultHidden: true,
      showVisibilityRules: true,
    },
  },
};

const dataFormFields = [1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 13, 19, 20];

const fieldTypeOptions: ISelectOption[] = [
  {id: FormFieldTypeLegacyEnum.AssetModal, label: 'Asset Selector'},
  {id: FormFieldTypeLegacyEnum.Checkbox, label: 'Checkbox'},
  {id: FormFieldTypeLegacyEnum.Date, label: 'Date'},
  {id: FormFieldTypeLegacyEnum.Divider, label: 'Divider'},
  {id: FormFieldTypeLegacyEnum.Dropdown, label: 'Dropdown'},
  {id: FormFieldTypeLegacyEnum.FileUpload, label: 'File Upload'},
  {id: FormFieldTypeLegacyEnum.TextInput, label: 'Text Box'},
  {id: FormFieldTypeLegacyEnum.Paragraph, label: 'Paragraph'},
  {id: FormFieldTypeLegacyEnum.PhoneNumber, label: 'Phone Number'},
  {id: FormFieldTypeLegacyEnum.RichText, label: 'Rich Content'},
  {id: FormFieldTypeLegacyEnum.Scale, label: 'Scale'},
  {id: FormFieldTypeLegacyEnum.Heading, label: 'Section Title'},
  {id: FormFieldTypeLegacyEnum.Signature, label: 'Signature'},
  {id: FormFieldTypeLegacyEnum.Subform, label: 'Sub Form'},
];

function getFieldTypeDictionaryName(id: number): string {
  switch (id) {
    case FormFieldTypeLegacyEnum.AssetModal:
      return 'asset';
    case FormFieldTypeLegacyEnum.Checkbox:
      return 'yes-no';
    case FormFieldTypeLegacyEnum.Date:
      return 'date-picker';
    case FormFieldTypeLegacyEnum.Divider:
      return 'divider';
    case FormFieldTypeLegacyEnum.Dropdown:
      return 'item-select-single';
    case FormFieldTypeLegacyEnum.FileUpload:
      return 'document-upload';
    case FormFieldTypeLegacyEnum.TextInput:
      return 'single-text';
    case FormFieldTypeLegacyEnum.Paragraph:
      return 'paragraph';
    case FormFieldTypeLegacyEnum.PhoneNumber:
      return 'phone-number';
    case FormFieldTypeLegacyEnum.RichText:
      return 'rich-content';
    case FormFieldTypeLegacyEnum.Scale:
      return 'scale';
    case FormFieldTypeLegacyEnum.Heading:
      return 'heading';
    case FormFieldTypeLegacyEnum.Signature:
      return 'signature';
    case FormFieldTypeLegacyEnum.Subform:
      return 'subform';
    default:
      return '';
  }
}

const yesNoOptions: ISelectOption[] = [
  {id: 'yes', label: 'Yes'},
  {id: 'no', label: 'No'},
];

const noYesOptions: ISelectOption[] = [
  {id: 'no', label: 'No'},
  {id: 'yes', label: 'Yes'},
];

const noYesBooleanOptions: ISelectOption[] = [
  {id: 'false', label: 'No'},
  {id: 'true', label: 'Yes'},
];

const activeInactiveBooleanOptions: ISelectOption[] = [
  {id: 'false', label: 'Inactive'},
  {id: 'true', label: 'Active'},
];

const showHideOptions: ISelectOption[] = [
  {id: 'show', label: 'Show'},
  {id: 'hide', label: 'Hide'},
];

const dropDownTypeOptions: ISelectOption[] = [
  {id: 'personnel', label: 'Personnel'},
  {id: 'custom', label: 'Custom Options'},
];

const validationTypes: ISelectOption[] = [
  {id: FormFieldTypeValidationEnum.Name.toString(), label: 'Name'},
  {id: FormFieldTypeValidationEnum.Email.toString(), label: 'Email'},
  {id: FormFieldTypeValidationEnum.Address.toString(), label: 'Address'},
  {id: FormFieldTypeValidationEnum.Time.toString(), label: 'Time'},
  {id: FormFieldTypeValidationEnum.Number.toString(), label: 'Number'},
  {id: FormFieldTypeValidationEnum.Url.toString(), label: 'Url'},
  {id: FormFieldTypeValidationEnum.Percent.toString(), label: 'Percent'},
  {id: FormFieldTypeValidationEnum.Currency.toString(), label: 'Currency'},
  {id: FormFieldTypeValidationEnum.DecimalNumber.toString(), label: 'Decimal'},
];

const subFormTypeOptions: ISelectOption[] = [
  {id: 1, label: 'Internal'},
  {id: 2, label: 'External'},
  {id: 3, label: 'Both'},
];

export {
  activeInactiveBooleanOptions,
  dataFormFields,
  dropDownTypeOptions,
  fieldTypeOptions,
  getFieldTypeDictionaryName,
  noYesBooleanOptions,
  noYesOptions,
  showHideOptions,
  subFormTypeOptions,
  validationTypes,
  yesNoOptions,
};

export default fieldTypeDictionary;
